import classNames from "classnames";

import style from "./ToolButton.module.css";

interface ToolButtonProps extends React.HTMLProps<HTMLDivElement> {
  icon: string;
  isActive?: boolean;
  shouldShowLabel?: boolean;
  label?: string;
  activeLabel?: string;
}

export const ToolButton: React.FC<ToolButtonProps> = ({
  icon,
  isActive,
  shouldShowLabel,
  label,
  activeLabel,
  ...props
}) => {
  return (
    <div
      {...props}
      className={classNames(style.buttonWrapper, props.className, isActive && style.active)}
      role="button"
    >
      <div
        className={classNames(style.buttonInside)}
        style={{ backgroundImage: `url(${icon})`, backgroundRepeat: "no-repeat" }}
      />
      {shouldShowLabel && (
        <div className={style.buttonLabelWrapper}>
          <div className={classNames(style.buttonLabel, !isActive && style.showOnHover)}>
            {isActive ? activeLabel : label}
          </div>
        </div>
      )}
    </div>
  );
};
